var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b;
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import theme from '../consts/theme';
var baseStyles = css({
    color: theme.colors.helsinkiBlueDark,
    fontFamily: theme.fontFamily.sans,
    fontWeight: 'normal',
    margin: 0,
});
var stylesByVariant = {
    h2: css((_a = {
            fontSize: '2rem',
            fontWeight: '300',
            lineHeight: 1.25,
            letterSpacing: 0
        },
        _a[theme.breakpoints.lg] = {
            fontSize: '2.5rem',
        },
        _a)),
    h3: css((_b = {
            fontSize: '1.375rem',
            fontWeight: '300',
            lineHeight: 1.25,
            letterSpacing: 0
        },
        _b[theme.breakpoints.lg] = {
            fontSize: '2rem',
        },
        _b)),
    caption: css({
        fontSize: '0.75rem',
        lineHeight: 1.5,
    }),
    body: css({
        fontSize: '1rem',
        lineHeight: 1.5,
    }),
};
var Typography = function (_a) {
    var children = _a.children, css = _a.css, _b = _a.variant, variant = _b === void 0 ? 'body' : _b, _c = _a.El, El = _c === void 0 ? 'p' : _c, props = __rest(_a, ["children", "css", "variant", "El"]);
    return (_jsx(El, __assign({ css: [baseStyles, stylesByVariant[variant], css] }, props, { children: children })));
};
export default Typography;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHlwb2dyYXBoeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1R5cG9ncmFwaHkudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUdyQyxPQUFPLEtBQUssTUFBTSxpQkFBaUIsQ0FBQztBQWFwQyxJQUFNLFVBQVUsR0FBRyxHQUFHLENBQUM7SUFDckIsS0FBSyxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsZ0JBQWdCO0lBQ3BDLFVBQVUsRUFBRSxLQUFLLENBQUMsVUFBVSxDQUFDLElBQUk7SUFDakMsVUFBVSxFQUFFLFFBQVE7SUFDcEIsTUFBTSxFQUFFLENBQUM7Q0FDVixDQUFDLENBQUM7QUFFSCxJQUFNLGVBQWUsR0FBZ0Q7SUFDbkUsRUFBRSxFQUFFLEdBQUc7WUFDTCxRQUFRLEVBQUUsTUFBTTtZQUNoQixVQUFVLEVBQUUsS0FBSztZQUNqQixVQUFVLEVBQUUsSUFBSTtZQUNoQixhQUFhLEVBQUUsQ0FBQzs7UUFDaEIsR0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsSUFBRztZQUN0QixRQUFRLEVBQUUsUUFBUTtTQUNuQjtZQUNEO0lBQ0YsRUFBRSxFQUFFLEdBQUc7WUFDTCxRQUFRLEVBQUUsVUFBVTtZQUNwQixVQUFVLEVBQUUsS0FBSztZQUNqQixVQUFVLEVBQUUsSUFBSTtZQUNoQixhQUFhLEVBQUUsQ0FBQzs7UUFDaEIsR0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUUsSUFBRztZQUN0QixRQUFRLEVBQUUsTUFBTTtTQUNqQjtZQUNEO0lBQ0YsT0FBTyxFQUFFLEdBQUcsQ0FBQztRQUNYLFFBQVEsRUFBRSxTQUFTO1FBQ25CLFVBQVUsRUFBRSxHQUFHO0tBQ2hCLENBQUM7SUFDRixJQUFJLEVBQUUsR0FBRyxDQUFDO1FBQ1IsUUFBUSxFQUFFLE1BQU07UUFDaEIsVUFBVSxFQUFFLEdBQUc7S0FDaEIsQ0FBQztDQUNILENBQUM7QUFFRixJQUFNLFVBQVUsR0FBRyxVQUFDLEVBTUY7SUFMaEIsSUFBQSxRQUFRLGNBQUEsRUFDUixHQUFHLFNBQUEsRUFDSCxlQUFnQixFQUFoQixPQUFPLG1CQUFHLE1BQU0sS0FBQSxFQUNoQixVQUFRLEVBQVIsRUFBRSxtQkFBRyxHQUFHLEtBQUEsRUFDTCxLQUFLLGNBTFUsb0NBTW5CLENBRFM7SUFDMEIsT0FBQSxDQUNsQyxLQUFDLEVBQUUsYUFBQyxHQUFHLEVBQUUsQ0FBQyxVQUFVLEVBQUUsZUFBZSxDQUFDLE9BQU8sQ0FBQyxFQUFFLEdBQUcsQ0FBQyxJQUFNLEtBQUssY0FDNUQsUUFBUSxJQUNOLENBQ04sQ0FBQTtDQUFBLENBQUM7QUFFRixlQUFlLFVBQVUsQ0FBQyJ9